import { faultLabel } from '../../domain/faults';

interface FaultRow {
  id: string;
  kind: string;
  entityKind: string;
  entityName: string;
  severity: string;
  firstObservedAt: string;
  clearedAt: string | null;
  description?: string;
  acknowledgedAt?: string | null;
  acknowledgedBy?: string | null;
}

export function FaultRow({
  row,
  onAcknowledge,
  acking = false,
}: {
  row: FaultRow;
  // When provided, renders an Acknowledge button. Wired from FaultsPage.
  onAcknowledge?: (() => void) | undefined;
  acking?: boolean;
}) {
  const acked = Boolean(row.acknowledgedAt);
  return (
    <div className="card">
      <div className="card-header">
        <strong>{faultLabel(row.kind)}</strong>
        <span style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
          <span className={`tag ${row.severity}`}>{row.severity}</span>
          <span className={`tag ${row.clearedAt ? 'closed' : 'heat'}`}>
            {row.clearedAt ? 'cleared' : 'active'}
          </span>
          {acked && <span className="tag open">acknowledged</span>}
          {!acked && onAcknowledge && (
            <button className="secondary" disabled={acking} onClick={onAcknowledge}>
              {acking ? 'Acknowledging…' : 'Acknowledge'}
            </button>
          )}
        </span>
      </div>
      <div className="muted" style={{ fontSize: 'var(--fs-sm)' }}>
        <code>{row.kind}</code> · {row.entityKind}:{row.entityName} · first{' '}
        {new Date(row.firstObservedAt).toLocaleString()}
        {row.clearedAt && ` · cleared ${new Date(row.clearedAt).toLocaleString()}`}
        {acked && ` · acknowledged ${new Date(row.acknowledgedAt as string).toLocaleString()}`}
      </div>
      {row.description && <div style={{ marginTop: 'var(--sp-2)' }}>{row.description}</div>}
    </div>
  );
}
